import { Box, Flex, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronLeftOutline, ChevronRightOutline } from '@bonusly/ds-icon';
import { Text } from '@bonusly/ds-typography';

import { useMonthPickerContext } from '../month-picker-context';

type MonthPickerControlsProps = StyleProps;

// Controls to navigate through years and displays the current year.
export const MonthPickerControls: FC<MonthPickerControlsProps> = (props) => {
	const { t } = useTranslation('components');
	const { onPrevYear, onNextYear, currentYear } = useMonthPickerContext();

	return (
		<Flex justifyContent="space-between" alignItems="center" mb={3} {...props}>
			<Box aria-label={t('date_picker.previous_year')} as="button" onClick={onPrevYear} type="button">
				<ChevronLeftOutline />
			</Box>

			<Text variant="strong">{currentYear}</Text>

			<Box aria-label={t('date_picker.next_year')} as="button" onClick={onNextYear} type="button">
				<ChevronRightOutline />
			</Box>
		</Flex>
	);
};
